import React, { useMemo, useState } from "react";
import Grid from "@mui/material/Grid2";
import { useSelector } from "react-redux";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Checkbox from "@mui/material/Checkbox";
import MaterialUiDataGridPremium from "../../../../components/Tables/DataGridPremium/MaterialUiDataGridPremium";

const ZoneTablePanel = (props) => {
  const { shapeType, zones } = props;
  const history = useSelector((state) => state.router?.location) || window.location;
  
  const facilityId = props?.activeMarker?.facilityId || history?.pathname?.split("/")?.pop();

  const facilityZones = useMemo(() => {
    return Object.values(zones).filter((zone) => zone.facilityId === facilityId && zone.internalZoneType === "processing");
  }, [zones, facilityId]);

  const [selectedEditableZoneIds, setSelectedEditableZoneIds] = useState([]);

  const handleCheckboxChange = (zoneId) => {
    setSelectedEditableZoneIds((prev) =>
      prev.includes(zoneId) ? prev.filter((id) => id !== zoneId) : [...prev, zoneId]
    );
  };

  const columns = [
    {
      field: "name",
      headerName: "Zone Name",
      flex: 1
    },
    // {
    //   field: "center",
    //   headerName: "Center Coordinates",
    //   valueGetter: ({ row }) => {
    //     // console.log("params in center:", params);
    //     const coords = row?.coordinates;
    //     if (!coords?.length) return "";
    //     const latSum = coords.reduce((sum, pt) => sum + pt.lat, 0);
    //     const lngSum = coords.reduce((sum, pt) => sum + pt.lng, 0);
    //     const lat = (latSum / coords.length).toFixed(5);
    //     const lng = (lngSum / coords.length).toFixed(5);
    //     return `${lat}, ${lng}`;
    //   },
    //   flex: 1.5
    // },
    // {
    //   field: "radius",
    //   headerName: "Radius",
    //   valueGetter: () => "N/A", // Placeholder — update if needed
    //   flex: 1
    // },
    // {
    //   field: "editable",
    //   headerName: "Editable",
    //   renderCell: ({ row }) => (
    //     <Checkbox
    //       checked={selectedEditableZoneIds.includes(row?.id)}
    //       onChange={() => handleCheckboxChange(row?.id)}
    //     />
    //   ),
    //   sortable: false,
    //   flex: 0.8
    // },
    {
      field: "actions",
      headerName: "Actions",
      sortable: false,
      renderCell: () => (
        <>
          <IconButton size="small">
            <EditIcon fontSize="small" />
          </IconButton>
          <IconButton size="small" color="error">
            <DeleteIcon fontSize="small" />
          </IconButton>
        </>
      ),
      flex: 1
    }
  ];

  return (
    <>
        <MaterialUiDataGridPremium
          rows={zones}
          columns={columns}
          getRowId={(row) => row?.id || row?.zoneId || row?.name}
          autoHeight
          checkboxSelection={false}
          hideFooter={false}
          pagination={true}
          pageSize={10}
          showGridToolBar={true}
        />
        </>
  );
};

export default ZoneTablePanel;
